<template>
    <div v-cloak v-if="show" class="toast" role="alert">
        <div class="toast-header">
            <h6 class="tx-inverse text-sm mb-0 mr-auto">
                {{ notification.title || 'Notification' }}
            </h6>

            <small>
                just now
                <!-- {{ relative(notification.created_at) }} -->
            </small>

            <button @click="close" type="button" class="ml-4 close font-normal focus:outline-none" data-dismiss="toast" aria-label="Close">
                <span aria-hidden="true">
                    <i class="fad fa-times-square"></i>
                    <!-- <i class="fal fa-times"></i> -->
                    <!-- &times; -->
                </span>
            </button>
        </div>

        <div class="toast-body">
            <div class="media">
                <div class="avatar avatar-sm">
                    <img :src="notification.image_url" :alt="notification.name" class="rounded-circle" />
                </div>

                <div class="media-body ml-4 mr-8">
                    <p class="mb-2 text-xs" class2="text-sm">
                        <a @click.prevent="view" :href="notification.link">
                            {{ notification.description }}
                        </a>
                    </p>

                    <button @click="open" type="button" class="btn btn-xs btn-block btn-primary border-2 rounded-full font-semibold" class2="btn-sm">
                        <i class="fad fa-shopping-cart fa-lg mr-1"></i>
                        Buy Now
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['notification'],

    data: () => ({
        show: true,
        timer: null
    }),

    created() {
        this.attachListener();
    },

    mounted() {
        this.trackRawEvent('notification_open', {
            notification_id: this.notification.id
        });
    },

    beforeDestroy() {
        this.detachListener();
    },

    computed: {},

    methods: {
        attachListener() {
            this.timer = setInterval(this.close, 120000);
        },

        detachListener() {
            clearInterval(this.timer);
        },

        open() {
            window.open(this.notification.url, '_blank');

            this.trackRawEvent('notification_click', {
                notification_id: this.notification.id
            });
        },

        close() {
            // @todo mark as read?

            this.trackRawEvent('notification_dismiss', {
                notification_id: this.notification.id
            });

            this.show = false;
        },

        view() {
            window.location.href = this.notification.link;
        }
    }
}
</script>

<style lang="scss" scoped>
.toast {
    opacity: 1;
}
</style>
